import type React from "react";
import { useParams } from "react-router-dom";
import { ErrorBanner } from "../../../components/Error/ErrorBanner";
import { OneCardPage } from "../../../components/utils/OneCardPage";
import { useGetWirelessSurvey } from "../../../hooks/getEntity";
import { NotFoundErrorForEntity } from "../../../model/error";
import { useSelectedCompany } from "../../../reducers/company";
import WirelessSurveyHeading from "./WirelessSurveyHeading";
import WirelessSurveyTabs from "./WirelessSurveyTabs";

export default function WirelessSurveyHomepage(): React.ReactElement {
  const { surveyId } = useParams();
  const company = useSelectedCompany();

  if (surveyId === undefined || company === undefined) {
    throw new Error("survey and company must be defined");
  }

  const { data, loading, error, refresh } = useGetWirelessSurvey(
    surveyId,
    company.company_id,
  );

  if (error) {
    return (
      <OneCardPage
        headerTitle={"Survey"}
        breadcrumbs={[{ name: "Error" }]}
        setPageTitle={() => "Wireless Survey: Error"}
      >
        <ErrorBanner error={error} />
      </OneCardPage>
    );
  }

  if (loading) {
    return (
      <OneCardPage
        headerTitle={"Survey"}
        loading={true}
        breadcrumbs={[{ name: "Loading" }]}
        setPageTitle={() => "Wireless Survey: Loading"}
      />
    );
  }

  if (!data) {
    return (
      <OneCardPage
        headerTitle={"Survey"}
        breadcrumbs={[{ name: "Not Found" }]}
        setPageTitle={() => "Wireless Survey: Not Found"}
      >
        <ErrorBanner
          error={NotFoundErrorForEntity("Wireless Survey", surveyId)}
        />
      </OneCardPage>
    );
  }

  return (
    <OneCardPage
      headerTitle={"Survey"}
      breadcrumbs={[
        { name: "Surveys", url: "/admin/asset_register/wireless_survey" },
        { name: data.survey_name },
      ]}
      setPageTitle={() => `Wireless Survey: ${data.survey_name}`}
    >
      <WirelessSurveyHeading survey={data} />
      <WirelessSurveyTabs survey={data} refreshSurvey={refresh} />
    </OneCardPage>
  );
}
